import { Check, X } from "lucide-react";
import { useI18n } from "@/lib/i18n";

export default function Comparison() {
  const { t } = useI18n();
  const basic = t("compare.basic");
  const raknati = t("compare.raknati");
  const maxLen = Math.max(basic.length, raknati.length);

  return (
    <section className="section bg-brand-sand" data-testid="section-compare">
      <div className="container-x">
        <div className="max-w-3xl">
          <div className="eyebrow">{t("compare.eyebrow")}</div>
          <h2 className="h2 mt-4">{t("compare.title")}</h2>
          <p className="lede mt-5">{t("compare.lede")}</p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-5">
          <div className="rounded-3xl border border-brand-line bg-white p-8">
            <div className="flex items-center justify-between">
              <div className="text-lg font-bold text-brand-charcoal">{t("compare.basic_title")}</div>
              <span className="text-[10px] uppercase tracking-widest font-semibold text-brand-charcoal/50">
                Generic
              </span>
            </div>
            <ul className="mt-6 space-y-3">
              {Array.from({ length: maxLen }).map((_, i) => (
                <li key={i} className="flex items-start gap-3 text-sm text-brand-charcoal/70">
                  {basic[i] ? (
                    <>
                      <span className="mt-0.5 h-5 w-5 rounded-full bg-brand-charcoal/5 flex items-center justify-center text-brand-charcoal/40 shrink-0">
                        <X className="h-3 w-3" />
                      </span>
                      <span>{basic[i]}</span>
                    </>
                  ) : (
                    <span className="text-brand-charcoal/30">—</span>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-3xl border-2 border-brand-green bg-white p-8 relative shadow-soft">
            <div className="absolute -top-3 start-6 bg-brand-green text-white text-[10px] font-bold uppercase tracking-[0.2em] px-3 py-1 rounded-full">
              Raknati
            </div>
            <div className="flex items-center justify-between">
              <div className="text-lg font-bold text-brand-charcoal">{t("compare.raknati_title")}</div>
              <span className="text-[10px] uppercase tracking-widest font-semibold text-brand-green">
                Purpose-built
              </span>
            </div>
            <ul className="mt-6 space-y-3">
              {raknati.map((r, i) => (
                <li key={i} className="flex items-start gap-3 text-sm font-medium text-brand-charcoal">
                  <span className="mt-0.5 h-5 w-5 rounded-full bg-brand-green text-white flex items-center justify-center shrink-0">
                    <Check className="h-3 w-3" />
                  </span>
                  <span>{r}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
